import React from 'react'

import { StandardText, StandardTextProps } from 'src/components/global/standardText'
import { ProductGrid, ProductGridProps } from 'src/components/global/productGrid'
import { NestedPages, NestedPagesProps } from 'src/components/global/nestedPages'
import { VideoModule, VideoModuleProps } from 'src/components/global/videoModule'
import { TwoColumn, TwoColumnProps } from 'src/components/global/twoColumn'


export const Modules = ({ reactModule, type }: { type: string, reactModule: any }) => {
  switch(type) {
    case 'standardText':
      return <StandardText data={reactModule as StandardTextProps["data"]} />
      case 'videoModule':
        return <VideoModule data={reactModule as VideoModuleProps["data"]} />
      case 'twoColumnText':
        return <TwoColumn data={reactModule as TwoColumnProps["data"]} />
      case 'productGrid':
        return <ProductGrid data={reactModule as ProductGridProps["data"]} />
      case 'nestedPages':
        return <NestedPages data={reactModule as NestedPagesProps["data"]} />
    default:
      return (<span>{type}</span>)
  }
}